import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import { isGrowing, sparkHeights } from "../lib/diff-format";

interface SparklineProps {
  trend: number[];
  over: boolean;
  testId?: string;
}

export function Sparkline({ trend, over, testId }: SparklineProps): JSX.Element {
  const { t } = useTranslation("inventory_diff");
  const heights = sparkHeights(trend);
  const barColor = over ? "var(--intent-danger-fg)" : "var(--text-subtle)";
  return (
    <span data-testid={testId} className="inline-flex items-end gap-[2px] h-5 align-middle">
      {heights.map((h, i) => (
        <span
          key={i}
          aria-hidden
          className="w-[3px] rounded-sm"
          style={{ height: `${Math.max(6, h)}%`, background: barColor }}
        />
      ))}
      {over && isGrowing(trend) && (
        <span className="ml-1 text-[10px] font-semibold text-[var(--intent-danger-fg)]">
          ▲ {t("state.growing")}
        </span>
      )}
    </span>
  );
}
